<script>
    import ProductInformation from "./ProductInformation.svelte";
    import EnergyEfficiency from "./EnergyEfficiency.svelte";
    import ImageTile from "./ImageTile.svelte";
    import clickTracker from "../tracking/clickTracker";
    import Sustainability from "./Sustainability.svelte";
    import BenefitBadge from "./BenefitBadge.svelte";
    import DiscountTag from "./DiscountTag.svelte";
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        recommendation,
        featuresState = {},
        lazyLoad,
        cinemaTracking,
        featureIndex,
        cinemaIndex,
        cinemaMeta,
        additionalCinemaClickTracking,
        cinemaId,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
        wishlist_class = false,
        showTopInfo = false,
        personalisedUser = false,
        trackAdd2BasketVisibility,
    } = $props();

    const tileDimensions = getContext(cinemaTileDimensionCtxKey);

    const {
        brandName,
        image,
        _embedded: { "o:variation": variation },
        formattedPrice,
        deal = {},
        tracking,
        veryPopular,
        minimumOrderValueEligible,
    } = $derived(recommendation);

    const discountValue = $derived(featuresState.ENABLE_DISCOUNT_TAG_IN_RECOMMENDATION ? variation.discountValue : null);
    const showNewPriceComponent = featuresState.ENABLE_NEW_PRICE_COMPONENT;
    const showEnergyEfficiency = $derived(
        Array.isArray(variation.energyEfficiencyClasses) && variation.energyEfficiencyClasses.length >= 1
    );

    const baseDetailViewUrl = $derived(variation._links["o:base-detail-view-url"]?.href);
    const variationDetailViewUrl = $derived(variation._links["o:detail-view"]?.href);
    const conditionalBaseDetailViewUrl = $derived(!baseDetailViewUrl ? {} : { href: baseDetailViewUrl });
    const tag = !baseDetailViewUrl ? "span" : "a";
    const clickHandler = () => {
        clickTracker({
            cinemaTracking,
            recommendationTracking: tracking,
            featureIndex,
            cinemaIndex,
            additionalCinemaClickTracking,
            additionalRecommendationClickTracking: recommendation.additionalClickTracking,
            cinemaMeta,
            recommendationMeta: recommendation.meta,
            additionalTrackingLabels,
            additionalNextPiTrackingLabels,
        });
    };

    const getDataTracking = () => {
        const promoSource = recommendation.tracking?.labels?.promo_Source;
        const promoTypeSuffix = recommendation.tracking?.name?.split("-")[0];

        if (!promoSource || !promoTypeSuffix) {
            return undefined;
        }

        return '{"promo_Source":"' + promoSource + '","promo_Type":"' + `promo_${promoTypeSuffix}` + '"}';
    };

    const radioEquipmentAttributes = {};
    if (variation.radioEquipmentRegulation?.chargingDeviceIncluded) {
        radioEquipmentAttributes["charging-device"] = true;
    }

    if (variation.radioEquipmentRegulation?.supportsUsbPowerDelivery) {
        radioEquipmentAttributes["usb-pd"] = true;
    }
</script>

<div
    style:min-width={`${tileDimensions.minimumWidth}px`}
    class="reco_cinema__tile"
    class:wishlist_class
    data-tracking={getDataTracking()}
    data-tracking-feature-id={tracking?.id}
    data-qa="slidingCinemaPromotion"
    data-testid="recommendation-tile"
>
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <oc-link-v2 variant="secondary" base64-href={btoa(variationDetailViewUrl)} onclick={clickHandler} data-testid="reco-card">
        <svelte:element this={tag} {...conditionalBaseDetailViewUrl} class="reco_cinema__adslink">
            <oc-card-v2>
                <ImageTile {image} {lazyLoad} variationId={variation.id} isVeryPopular={veryPopular} {personalisedUser} />
            </oc-card-v2>
            <ProductInformation
                {brandName}
                {variation}
                pricing={formattedPrice}
                {deal}
                {showTopInfo}
                additionalClickTracking={recommendation.additionalClickTracking}
                widgetAdditionalClickTracking={additionalCinemaClickTracking}
                {trackAdd2BasketVisibility}
            />
        </svelte:element>
    </oc-link-v2>
    {#if !showNewPriceComponent}
        <div class="reco_cinema__taglist">
            <DiscountTag {discountValue} />
            <BenefitBadge variationId={variation.id} />
        </div>
    {/if}
    {#if minimumOrderValueEligible}
        <oc-logo-v1 data-testid="ottoUp_logo" fill-parent class="oc-mt-50 reco_cinema__otto-up-logo" logo="otto-up"></oc-logo-v1>
    {/if}
    {#if showEnergyEfficiency}
        <div class="oc-mt-50">
            <EnergyEfficiency energyEfficiencyClasses={variation.energyEfficiencyClasses} />
        </div>
    {/if}
    <Sustainability labels={variation.sustainabilities} variationId={variation.id} {cinemaId} {cinemaTracking} />
    {#if featuresState.SHOW_RADIO_EQUIPMENT_REGULATION && variation.radioEquipmentRegulation?.chargingPower}
        <ofc-radio-equipment-regulation-v1
            class="reco_cinema__radio-equipment-regulation"
            size="50"
            min-power={variation.radioEquipmentRegulation.chargingPower?.min}
            max-power={variation.radioEquipmentRegulation.chargingPower?.max}
            {...radioEquipmentAttributes}
        >
        </ofc-radio-equipment-regulation-v1>
    {/if}
</div>

<style lang="scss">
    .reco_cinema__tile {
        display: flex;
        flex-direction: column;
        margin: 0 8px 0 0;
        vertical-align: top;
        white-space: normal;
        position: relative;
        height: 100%;

        &:last-child {
            margin-right: 0;
        }
    }

    .reco_cinema__radio-equipment-regulation {
        padding-top: 8px;
    }

    .reco_cinema__taglist {
        display: flex;
        flex-wrap: wrap;
    }

    .reco_cinema__adslink {
        color: black;
        text-decoration: none;
        overflow-y: auto;
    }

    .reco_cinema__adslink:hover:not(:has(:hover)) {
        text-decoration: black underline;
    }

    .reco_cinema__adslink:has(oc-button-v1:hover) {
        text-decoration: none;
    }

    .reco_cinema__adslink:hover :global(.reco_cinema__price-per-unit) {
        text-decoration: grey underline;
    }

    .reco_cinema__otto-up-logo {
        width: 52px;
        height: 16px;
    }
</style>
